import React, { JSX } from 'react';

type TranslationStatusProps = 'success' | 'pending' | 'error';

interface Props {
    value: TranslationStatusProps;
}

export const TranslationStatusRow = ({ value }: Props): JSX.Element => {
  const getStatusStyle = () : string => {
    switch (value) {
      case 'success':
        return 'text-green-600 font-medium';
      case 'pending':
        return 'text-orange-500 font-medium animate-pulse';
      case 'error':
        return 'text-red-600 font-medium';
      default:
        return '';
    }
  };

  const getLabel = () => {
    switch (value) {
      case 'success':
        return 'Translated';
      case 'pending':
        return 'Translating...';
      case 'error':
        return 'Translation Failed';
      default:
        return '';
    }
  };

  return (<span className={getStatusStyle()}>{getLabel()}</span>);
};
